import styled from "styled-components";
import { FaLinkedin, FaYoutube } from "react-icons/fa6";
import { FaXTwitter } from "react-icons/fa6";
import logo from "../static/images/storlytics_white.png";
import CookieConsent from "react-cookie-consent";
import { MdLocationOn } from "react-icons/md";
import { useNavigate } from "react-router-dom";

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const navigate = useNavigate();
  const redirectPage = (page) => {
    navigate(page);
  };
  
  return (
    <FooterContainer>
      <TopSection>
        <LogoSection>
          <img src={logo} height={48} alt="Storlytics logo" />
        </LogoSection>

        <Middle>
          <CopyRight>
            <span>&copy; {currentYear} Storlytics LLC Charlotte, NC</span>
          </CopyRight>
          <TermsBtn onClick={() => redirectPage("/terms-of-service")}>
            Terms of Service
          </TermsBtn>
          <PrivacyBtn onClick={() => redirectPage("/PrivacyPolicy/")}>
            Privacy Policy
          </PrivacyBtn>
        </Middle>

        <End>
          <SocialMedia>
            <a
              href="https://www.linkedin.com/company/storlytics/"
              aria-label="LinkedIn"
            >
              <FaLinkedin color="white" />
            </a>
            <a
              href="https://www.youtube.com/channel/UCgyxkGuz2X_jIximCXtk15w"
              aria-label="YouTube"
            >
              <FaYoutube color="white" />
            </a>
          </SocialMedia>
        </End>


      </TopSection>

      <CookieConsent
        location="bottom"
        buttonText="I Understand"
        cookieName="StorlyticsCookie2"
        style={{ background: "#2B373B" }}
        buttonStyle={{ color: "#4e503b", fontSize: "13px" }}
        expires={150}
      >
        <CookieText>
          This website stores cookies on your computer. These cookies are used
          to collect information about how you interact with our website and
          allow us to remember you.
          <br />
          We use this information in order to improve and customize your
          browsing experience and for analytics and metrics about our visitors
          both on this website and other media. To find out more about the
          cookies we use, see our <a href="/PrivacyPolicy">Privacy Policy</a>.
        </CookieText>
      </CookieConsent>
    </FooterContainer>
  );
};

export default Footer;

const FooterContainer = styled.footer`
  margin: 48px 0 0;
  background: #04ac4e;
  padding: 20px;
  color: white;

  @media (max-width: 576px) {
    padding: 16px; /* Reduce padding on mobile */
  }
`;


const TopSection = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: flex-start;
  gap: 20px;

  @media (max-width: 768px) {
    flex-direction: column; /* Stack items vertically on smaller screens */
    align-items: center; /* Center align items */
    gap: 16px; /* Reduce gap on mobile */
  }
`;
const End = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 17px;

  @media (max-width: 768px) {
    align-items: center;
  }
`;

const CopyRight = styled.div`
  font-size: 15px;
`

const Middle = styled.div`
  display: flex;
  margin-top: 16px;
  gap: 15px;
`

const TermsBtn = styled.a`
  background: transparent;
  border: none;
  color: white;                 
  font-weight: 600;
  text-decoration: none;        
  cursor: pointer;     
  margin-left: 30px;         

  &:hover,
  &:focus,
  &:active,
  &:visited {
    color: white;               
    text-decoration: none;      
  }
`;

const PrivacyBtn = styled.a`
  background: transparent;
  border: none;
  color: white;                 
  font-weight: 600;
  text-decoration: none;        
  cursor: pointer;              

  &:hover,
  &:focus,
  &:active,
  &:visited {
    color: white;               
    text-decoration: none;      
  }
`

const LogoSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-top: 7px;
  gap: 8px;

  span {
    font-size: 14px;
  }

  @media (max-width: 576px) {
    align-items: center; /* Center align logo and text */
    text-align: center; /* Center align text */
  }
`;
const CompanyInfo = styled.div`
  flex: 1;
  min-width: 200px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  font-size: 14px;
  line-height: 1.4;
  align-items: center;

  a {
    color: white;
    text-decoration: none;
    display: flex;
    align-items: center;
  }

  a:hover {
    text-decoration: underline;
  }

  span {
    display: flex;
    align-items: center;
  }
`;

const Summary = styled.p`
  margin: 0;
  font-size: 14px;
  line-height: 1.4;
  text-align: left;
`;

const Contact = styled.div`
  font-size: 14px;
  line-height: 1.4;

  a {
    color: white;
    text-decoration: none;
  }

  a:hover {
    text-decoration: underline;
  }

  span {
    display: block;
    margin-top: 4px;
  }
`;

const SocialMedia = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;

  a {
    display: inline-flex;
    width: 32px;
    height: 32px;
  }

  svg {
    width: 24px;
    height: 24px;
  }

  @media (max-width: 576px) {
    justify-content: center; /* Center align social media icons */
    gap: 12px; /* Increase spacing between icons */
  }
`;
const CookieText = styled.div`
  font-size: 13px;
  text-align: center; /* Center align cookie text on all screens */

  a {
    color: #a0d1a0;
  }

  @media (max-width: 576px) {
    font-size: 12px; /* Reduce font size on mobile */
  }
`;
